var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13537",
    "data-name": "Group 13537",
    transform: "translate(-0.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_5529",
    "data-name": "Path 5529",
    transform: "translate(0.235 0)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 76 83.5 L 8 83.5 C 3.864488840103149 83.5 0.5 80.13551330566406 0.5 76 L 0.5 8 C 0.5 3.864488840103149 3.864488840103149 0.5 8 0.5 L 76 0.5 C 80.13551330566406 0.5 83.5 3.864488840103149 83.5 8 L 83.5 76 C 83.5 80.13551330566406 80.13551330566406 83.5 76 83.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8 1 C 4.140190124511719 1 1 4.140190124511719 1 8 L 1 76 C 1 79.85980987548828 4.140190124511719 83 8 83 L 76 83 C 79.85980987548828 83 83 79.85980987548828 83 76 L 83 8 C 83 4.140190124511719 79.85980987548828 1 76 1 L 8 1 M 8 0 L 76 0 C 80.41827392578125 0 84 3.581718444824219 84 8 L 84 76 C 84 80.41827392578125 80.41827392578125 84 76 84 L 8 84 C 3.581718444824219 84 0 80.41827392578125 0 76 L 0 8 C 0 3.581718444824219 3.581718444824219 0 8 0 Z",
    stroke: "none",
    fill: "#c9c9c9"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Video_upload",
    "data-name": "Video upload",
    transform: "translate(16.235 64.394)",
    fill: "#c9c9c9",
    fontSize: 10,
    fontFamily: "Tajawal-Light, Tajawal",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Video upload")), /*#__PURE__*/React.createElement("path", {
    id: "film-solid",
    d: "M0,36.632A4.637,4.637,0,0,1,4.632,32H32.426a4.637,4.637,0,0,1,4.632,4.632V59.794a4.637,4.637,0,0,1-4.632,4.632H4.632A4.637,4.637,0,0,1,0,59.794ZM3.474,56.32v2.316a1.162,1.162,0,0,0,1.158,1.158H6.949a1.162,1.162,0,0,0,1.158-1.158V56.32a1.161,1.161,0,0,0-1.158-1.158H4.632A1.161,1.161,0,0,0,3.474,56.32ZM30.11,55.162a1.161,1.161,0,0,0-1.158,1.158v2.316a1.162,1.162,0,0,0,1.158,1.158h2.316a1.162,1.162,0,0,0,1.158-1.158V56.32a1.161,1.161,0,0,0-1.158-1.158ZM3.474,47.055v2.316a1.162,1.162,0,0,0,1.158,1.158H6.949a1.162,1.162,0,0,0,1.158-1.158V47.055A1.161,1.161,0,0,0,6.949,45.9H4.632A1.161,1.161,0,0,0,3.474,47.055ZM30.11,45.9a1.161,1.161,0,0,0-1.158,1.158v2.316a1.162,1.162,0,0,0,1.158,1.158h2.316a1.162,1.162,0,0,0,1.158-1.158V47.055A1.161,1.161,0,0,0,32.426,45.9ZM3.474,37.79v2.316a1.162,1.162,0,0,0,1.158,1.158H6.949a1.162,1.162,0,0,0,1.158-1.158V37.79a1.161,1.161,0,0,0-1.158-1.158H4.632A1.161,1.161,0,0,0,3.474,37.79ZM30.11,36.632a1.161,1.161,0,0,0-1.158,1.158v2.316a1.162,1.162,0,0,0,1.158,1.158h2.316a1.162,1.162,0,0,0,1.158-1.158V37.79a1.161,1.161,0,0,0-1.158-1.158ZM11.581,38.949v4.632A2.314,2.314,0,0,0,13.9,45.9h9.265a2.314,2.314,0,0,0,2.316-2.316V38.949a2.314,2.314,0,0,0-2.316-2.316H13.9A2.314,2.314,0,0,0,11.581,38.949ZM13.9,50.529a2.314,2.314,0,0,0-2.316,2.316v4.632A2.314,2.314,0,0,0,13.9,59.794h9.265a2.314,2.314,0,0,0,2.316-2.316V52.846a2.314,2.314,0,0,0-2.316-2.316Z",
    transform: "translate(24.235 -17.176)",
    fill: "#c9c9c9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoUpload);
export default __webpack_public_path__ + "static/media/video-upload.01b1372e75bc8c4d8a33986bf3e8cc62.svg";
export { ForwardRef as ReactComponent };